import React from 'react';
import { dispatchSignUpPageLoadSaikaEvent } from '../stuart/saika-events';
import { dispatchLoadEvent } from './metrics';
import CadastroPjForms from './cadastro-pj-forms';

export const DOCUMENT_CHECK = 'DOCUMENT_CHECK';
export const BUYER_AND_COMPANY = 'BUYER_AND_COMPANY';
export const BILLING_ADDRESS = 'BILLING_ADDRESS';
export const FINISH = 'FINISH';

class CadastroPjComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formState: DOCUMENT_CHECK,
      formDataState: {},
      customerQualifyerData: {},
      buyerAlreadyRegistered: false
    };
    this.setState = this.setState.bind(this);
  }

  componentDidMount() {
    dispatchLoadEvent('signUpPJ');
    dispatchSignUpPageLoadSaikaEvent();
  }

  render() {
    return (
      <div className="cadastroForm-container">
        <CadastroPjForms state={this.state} setCadastroPjDocumentState={this.setState} />
      </div>
    );
  }
}

export default CadastroPjComponent;
